// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { UploadTokens } from './type';

const uploadTokens: UploadTokens = {
  uploadResultPaddingX: 'Padding-16',
  uploadResultPaddingY: 'Padding-5',
  uploadResultBackgroundColor: 'Neutral-fill-2',
  uploadResultGap: 'Margin-4',
  uploadResultMarginY: 'Margin-8',
  uploadResultIconSize: 'Size-7',
  uploadResultIconColor: 'Neutral-text-4',
  uploadResultIconHoverBackgroundColor: 'Neutral-fill-2',
  uploadResultFontSize: '14/regular',
  uploadResultFontColor: 'Neutral-text-5',
  uploadResultBorderRadius: 'Radius-4',
  uploadResultErrorFontColor: 'Danger-6',
  uploadResultErrorIconColor: 'Danger-6',
  uploadResultSuccessIconColor: 'Success-6',
  uploadResultDeletedFontColor: 'Neutral-text-3',
  uploadResultUploadingIconColor: 'Brand-6',
  uploadImageBorderRadius: 'Radius-4',
  uploadImageHandlerBorderColor: 'Neutral-border-1',
  uploadImageHandlerBackgroundColor: 'Neutral-fill-1',
  uploadImageHandlerFontColor: 'Neutral-text-4',
  uploadImageHandlerHoverBorderColor: 'Brand-6',
  uploadImageHandlerHoverFontColor: 'Brand-6',
  uploadImageHandlerErrorBorderColor: 'Danger-6',
  uploadImageHandlerErrorFontColor: 'Danger-6',
  uploadImageHandlerDisabledBorderColor: 'Neutral-border-2',
  uploadImageHandlerDisabledBackgroundColor: 'Neutral-fill-2',
  uploadImageHandlerDisabledFontColor: 'Neutral-text-2',
  uploadImageResultBorderColor: 'Neutral-border-1',
  uploadImageResultBtnSize: 'Size-7',
  uploadImageResultBtnCloseColor: 'Danger-6',
  uploadImageResultBtnRecoverColor: 'Neutral-text-4',
  uploadImageResultMaskBackgroundColor: 'Mask-fill-1',
  uploadImageResultMaskIconSize: 'Size-8',
  uploadImageResultMaskIconColor: 'Neutral-text-1',
  uploadImageResultErrorBorderColor: 'Danger-6',
  uploadImageResultErrorFontColor: 'Danger-6',
  uploadImageResultTipBackgroundColor: 'Neutral-fill-1',
  uploadImageResultTipFontSize: '12/regular',
  uploadFontSize: '14/regular',
};

export default uploadTokens;
